<template>
  <d-modal
    class="patients-form-decisions"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <button
      @click.prevent="onClosePopup"
      :class="['mr-1', 'decisions-close-button', show ? 'decisions-close-button-load' : 'decisions-close-button-hidden']">
      <i class="material-icons">close</i>
    </button>
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja Opinii</template>
          <template v-else>Dodawanie Opinii</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="patients-form-opinion"
        tag="form">
        <div class="form-group">
          <label
            for="institution_id"
            class="title-box">
            Przypisana placówka:
          </label>
          <validation-provider
            :rules="'required'"
            name="institution_id"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                :options="allInstitutions"
                :reduce="institution => institution.id"
                v-model="data.institution_id"
                placeholder="Wybierz placówkę..."
                label="name">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="no-options">
                  Brak pasujących rezultatów
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="opinion-type">
            Wybierz opinię:
          </label>
          <validation-provider
            :rules="'required'"
            name="opinion-type"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                class="reservation-style reservation-style-select-mid"
                :options="opinionTypesList"
                v-model="selectedOpinionType"
                placeholder="Wybierz opinię..."
                label="name">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="no-options">
                  Brak pasujących rezultatów
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          v-if="!allDataLoaded"
          class="spinner-load">
          <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
        </div>
        <template v-if="opinionTemplateFields">
          <div
            v-for="(opinionField, opinionFieldIndex) in opinionTemplateFields"
            :key="'opinion-filed-' + opinionFieldIndex">
            <div
              v-if="opinionField.type === 'input' && selectedOpinionTypeID === 16 && opinionField.key === 'opinion_key'"
              class="form-group opinion-box mt-5">
              <label
                :for="opinionField.name"
                class="title-box">
                {{ opinionField.label }}
              </label>
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <d-input
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="opinionField.value" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="opinionField.text"
                class="opinion-note">
                {{ opinionField.text }}
              </p>
            </div>
            <div
              v-if="opinionField.type === 'input' && opinionField.key !== 'opinion_key' && opinionField.label !== 'Nazwa opini'"
              class="form-group opinion-box">
              <label
                :for="opinionField.name"
                class="title-box" >
                {{ opinionField.label }}
              </label>
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <d-input
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="opinionField.value" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="opinionField.text"
                class="opinion-note">
                {{ opinionField.text }}
              </p>
            </div>
            <div
              v-if="opinionField.type === 'input' && selectedOpinionTypeID === 16 && opinionField.label === 'Nazwa opini'"
              class="form-group opinion-box">
              <label
                :for="opinionField.name"
                class="title-box">
                {{ opinionField.label }}
              </label>
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <d-input
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="opinionField.value" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="opinionField.text"
                class="opinion-note">
                {{ opinionField.text }}
              </p>
            </div>
            <div
              v-if="opinionField.type === 'date'"
              class="form-group decision-box">
              <label
                :for="opinionField.name"
                class="title-box">
                {{ opinionField.label }}
              </label>
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <date-picker
                  v-model="opinionField.value"
                  valueType="format"
                  class="mr-2"
                  style="width: 100%" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="opinionField.text"
                class="decision-note">
                {{ opinionField.text }}
              </p>
            </div>
            <div
              v-if="opinionField.type === 'textarea'"
              class="form-group opinion-box">
              <label
                :for="opinionField.name"
                class="title-box">
                {{ opinionField.label }}
              </label>
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <textarea
                    :type="'text'"
                    :state="errors.length ? 'invalid' : null"
                    v-model="opinionField.value">
                  </textarea>
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="opinionField.text"
                class="opinion-note">
                {{ opinionField.text }}
              </p>
            </div>
            <div
              v-if="(opinionField.type === 'select') && (opinionField.multiselect === 0)"
              class="form-group opinion-box">
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <label class="mt-2">
                  {{ opinionField.label }}
                </label>
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <v-select
                    :options="opinionField.possibleValues"
                    v-model="opinionField.value"
                    :reduce="boss => boss.id"
                    label="name">
                  </v-select>
                </div>
                <p
                  v-if="opinionField.text"
                  class="decision-note">
                  {{ opinionField.text }}
                </p>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div
              v-if="(opinionField.type === 'select') && (opinionField.multiselect === 1) && (opinionField.specializations === true)"
              class="form-group opinion-box">
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <label
                  :for="opinionField.name"
                  class="title-box">
                  {{ opinionField.label }}
                </label>
                <multi-select
                  :multiple="true"
                  :ref="'multi-user-list'"
                  placeholder="Wybierz..."
                  :options="opinionField.possibleValues"
                  v-model="opinionField.value"
                  @input="getValueFromMultiSelect(opinionField.value)"
                  :track-by="'id'"
                  label="name"
                  select-label="Wybierz"
                  deselectLabel="Usuń wybór"
                  selectedLabel="Wybrane"
                  :taggable="true" />
                <p
                  v-if="opinionField.text"
                  class="decision-note">
                  {{ opinionField.text }}
                </p>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <div class="form-group" style="display: none">
                <pre>{{usersList}}</pre>
                <pre>{{data.specialization}}</pre>
                <pre>{{specialization}}</pre>
              </div>
              <div
                v-if="usersList.length  && opinionField.specializations === true"
                class="form-group under-box">
                <label
                  :for="opinionField.name"
                  class="title-box">
                  Specjalizacje zespołu
                </label>
                <div
                  v-for="(user, userIndex) in usersList"
                  :key="userIndex"
                  class="form-group">
                  <span>
                    <i class="material-icons text-success mr-2">chevron_right</i>
                    <label for="name" class="mr-4 mt-1">
                      {{ user.name }}
                    </label>
                    <validation-provider
                      rules="required"
                      name="specialization-selec'"
                      v-slot="{ errors }">
                      <div
                        :class="{
                          'form-control is-select': true,
                          'is-invalid': errors.length
                        }">
                        <v-select
                          :options="availableSpecializations"
                          @input="pushIdAndSpecialization(user.id, data.specialization[userIndex], userIndex)"
                          :reduce="boss => boss.id"
                          v-model="data.specialization[userIndex]"
                          label="name">
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="(opinionField.type === 'select') && (opinionField.multiselect === 1) && (opinionField.specializations === false)"
              class="form-group opinion-box">
              <validation-provider
                :name="opinionField.name"
                v-slot="{ errors }">
                <label
                  :for="opinionField.name"
                  class="title-box">
                  {{ opinionField.label }}
                </label>
                <multi-select
                  class="law-basics"
                  :multiple="true"
                  placeholder="Wybierz..."
                  :options="opinionField.possibleValues"
                  v-model="opinionField.value"
                  :track-by="'id'"
                  label="name"
                  select-label="Wybierz"
                  deselectLabel="Usuń wybór"
                  selectedLabel="Wybrane"
                  :taggable="true" />
                <p
                  v-if="opinionField.text"
                  class="decision-note">
                  {{ opinionField.text }}
                </p>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div
              v-if="opinionField.type === 'checkbox'"
              class="form-group decision-box">
              <d-checkbox
                :value="'1'"
                :unchecked-value="'0'"
                v-model="opinionField.value"
                :class="'mb-3'"
                toggle>
                <span class="title-box">{{ opinionField.label }}</span>
              </d-checkbox>
              <p
                v-if="opinionField.text"
                class="decision-note">
                {{ opinionField.text }}
              </p>
            </div>
          </div>
        </template>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FilterSelect from '@/components/others/FilterSelect';
import DatePicker from 'vue2-datepicker';
import multiSelect from 'vue-multiselect'
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'patients-form-opinions-popup',
  components: { FilterSelect, DatePicker, multiSelect },
  props: {
    editOpinionId: {
      required: true,
      type: Number
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    },
    show: {
      default: false,
      type: Boolean
    },
    visitId: {
      default: 0,
      type: Number
    },
    allInstitutions: {
      required: true,
      type: Array
    },
  },
  computed: {
    opinionTypesList () {
      return this.$store.getters.getPatientsOpinionList;
    },
    allDataLoaded () {
      return this.opinionTypesList && this.currentOpinionLoaded && this.opinionTemplateFields;
    },
    isEdit () {
      return !!this.editOpinionId;
    },
    opinionTemplateFields () {
      if (this.isEdit && this.currentOpinionLoaded) {
        return this.currentOpinion.data_fields;
      }

      if (!this.isEdit && this.data.opinion_id && this.additionalDataLoaded) {
        return this.opinionsTemplate;
      }

      return [];
    },
    availableSpecializations () {
      if (this.isEdit && this.currentOpinionLoaded) {
        return this.currentOpinion.specializations;
      }

      if (!this.isEdit && this.data.opinion_id && this.additionalDataLoaded) {
        return this.specializationsList;
      }

      return [];
    }
  },
  watch: {
    'selectedOpinionType': function (value) {
      if (value && value.id) {
        this.data.opinion_id = value.id;
        this.data.name = value.name;
        this.data.opinion_input = value.input;
      }
    },
    'data.opinion_id': function (value) {
      Vue.set(this, 'selectedOpinionTypeID', value || 0);
      if (!this.isEdit) {
        Vue.set(this, 'additionalDataLoaded', false);
        if (value) {
          this.loadAdditionalData();
        }
      }
      this.data.patient_id = this.patientId;
    }
  },
  data () {
    return {
      additionalDataLoaded: false,
      currentOpinion: {},
      currentOpinionLoaded: false,
      data: {
        id: '',
        name: '',
        opinion_id: '',
        opinion_input: false,
        institution_id: null,
        patient_id: '',
        specialization: []
      },
      loaded: false,
      loadError: false,
      opinionsTemplate: [],
      selectedOpinionType: null,
      selectedOpinionTypeID: 0,
      specialization: [],
      specializationsList: [],
      usersList: []
    };
  },
  mounted () {
    this.getOpinionsList();

    Vue.nextTick(() => {
      if (this.isEdit) {
        this.loadItemData();
      } else {
        this.currentOpinionLoaded = true;
      }
    })
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-opinion'], this.submitForm);
    },
    loadItemData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/opinions/item/' + this.editOpinionId,
        outputKey: 'currentOpinion',
        loadedKey: 'currentOpinionLoaded',
        successAction: () => {
          Vue.nextTick(() => {
            this.setupOpinion();
          })
        }
      });
    },
    setupOpinion () {
      this.data.patient_id = this.currentOpinion.patient_id;
      this.data.institution_id = this.currentOpinion.institution_id;
      this.data.opinion_id = this.currentOpinion.data_fields.opinion_id.value;
      this.selectedOpinionTypeID = this.currentOpinion.data_fields.opinion_id.value;
      this.specialization = this.currentOpinion.specialization;
      Vue.set(this, 'selectedOpinionType', this.opinionTypesList.find(item => item.id === this.currentOpinion.data_fields.opinion_id.value));

      setTimeout(() => {
        this.getValueFromMultiSelectEdit();
      }, 500);
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/opinions/template',
        loadedKey: 'additionalDataLoaded',
        noPagination: true,
        params: {
          opinion_id: this.data.opinion_id,
          patient_id: this.patientId,
          opinion_name: this.data.opinion_name,
        },
        successAction: (response) => {
          this.opinionsTemplate = response.data_fields;
          this.specializationsList = response.specializations;
        }
      });
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        patient_id: this.patientId,
        institution_id: this.data.institution_id,
        data_fields: this.opinionTemplateFields,
        id: this.data.opinion_id,
        specialization: this.specialization,
        visit_id: this.visitId
      };
      let endpointUrl = this.isEdit ? '/patients/opinions/update/' + this.editOpinionId : '/patients/opinions/store';
      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano opinię',
        successText: 'Wybrana opinia została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje opinii nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      }, imageFields);
    },
    getOpinionsList () {
      this.$store.dispatch('patientsOpinionListGet')
    },
    pushIdAndSpecialization(value, special, index) {
      this.specialization[index] = {
        id: value,
        specialization: special
      }
    },
    getValueFromMultiSelect(value) {
      this.usersList = value;
    },
    getValueFromMultiSelectEdit() {
      setTimeout(() => {
        for (let i = 0; i < this.specialization.length; i++) {
          if (this.$refs['multi-user-list'][i]) {
            if (this.$refs['multi-user-list'][i].internalValue.length) {
              const refValue = this.$refs['multi-user-list'][i].internalValue;
              for (let j = 0; j < refValue.length; j++) {
                this.usersList[j] = {
                  id: refValue[j].id,
                  name: refValue[j].name
                };
                this.data.specialization.push(refValue[j].specialization);
              }
            }
          }
        }
      }, 500);
    },
  }
}
</script>

<style lang="scss">
  .vs__dropdown-option {
    white-space: normal;
  }
  .law-basics {
    .multiselect__tags {
      .multiselect__tag {
        font-size: 12px;
      }
    }
    .multiselect__content-wrapper {
      span {
        font-size: 12px;
      }
    }
  }
</style>
